module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Bay Laurel"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Bay Laurel ")])])])])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Laurus nobilis ")])])])]), _c('p', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("In a notable herbal leap of faith, the thirteenth-century Arab ")])]), _c('p', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("physician Ibn al-Baitar believed that sporting a bay leaf behind ")])]), _c('p', {
    staticClass: "underline"
  }, [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("one’s ear could prevent inebriation. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he true culinary bay laurel"), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v(" (Laurus nobilis),")])]), _vm._v(" also known as sweet\n        bay, is antiquely native to the Mediterranean, India, and Africa alone, although its cousin\n        in the greater magnolia family, the California bay "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("(Umbellularia\n            californica),")])]), _vm._v(" also known as Oregon myrtle and pepperwood, is a close ringer\n        but of a stronger savor. The ancient Greeks considered the "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Laurus\n            nobilis")])]), _vm._v(" both sacred and protective and associated it with Apollo, who\n        fashioned himself a crown of laurel to celebrate the slaying of Python, the tempestuous\n        she-dragon of the underworld, upon whose former lair he built his Delphic temple and then\n        roofed it with bay leaves to protect it from lightning. Similar celebratory wreaths were\n        soon bestowed upon the winning athletes of the Pythian games at Delphi, ultimately graced\n        the locks of the first Olympians, and were awarded to the greatest early poets — thus “poet\n        laureate” — with our educationally esteemed baccalaureate, translating to “laurel berry.” ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Additionally, the Pythia, the anciently revered Apollonian Oracle of Delphi, is known to\n        have chewed bay leaves to intensify her oracular hallucinations, famously delivered in an\n        ecstatic trance and partially induced by what contemporary historians now believe were\n        ethylene vapors rising from fissures in the ground around her. Greek mythology also gives to\n        this savory herb its Greek name Daphne, in reference to the beautiful nymph daughter of the\n        river god Peneios and earth goddess Ge, whom they transformed into a bay laurel in order\n        that she might escape the prurient advances of Apollo. From that moment on, the bay laurel\n        was associated with purity, purification, and protection, with Nicholas Culpeper jumping\n        onto the “protective” bandwagon in his "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Complete Herbal")])]), _vm._v(" of 1653 and\n        attributing all kinds of pharmacological feats to the bay laurel, including the berries\n        being “very effectual against all poisons of venomous creatures” and the oil distilled from\n        them helping with “palsies, convulsions, cramps, aches, trembling, and numbness of any\n        part.” ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Contemporarily, because of the bay laurel’s strong camphorous fragrance, it is most\n        generally herbally employed as an aromatherapy oil in the treatment of such complaints as\n        colds, flu, and muscle aches. It is, however, its famous culinary merits that remain truly\n        commendable. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Additionally, "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Laurus nobilis")])]), _vm._v(" is a handsome tree with signature thick,\n        shiny, elliptical leaves, small pale-yellow flowers, and oval green berries, which will\n        ultimately turn black in fall. That said, here I am forced to admit that the bay laurel is\n        hardy only to USDA zones 8 through 10 and is a somewhat delicate creature, craving\n        protection from frost (a good, thick mulching of its notably shallow root system) and wind\n        (a sunny, sheltered location), and requiring rich, well-drained soil. ")])]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of Bay Laurel."
    }
  }, [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of Bay Laurel.",
      "src": "images/Bay_Laurel.jpg"
    }
  }), _c('div', {
    staticClass: "caption"
  }, [_c('p', [_vm._v("Bay Laurel")])])])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("However, as many ancient households habitually displayed a “protective” potted bay beside\n        the front door to ward off evil spirits, it is this employment I will recommend to the\n        greatest number of you here. The bay laurel is a splendid candidate for pot culture and,\n        loving a good spring pruning, may be kept to a manageable 6 to 8 feet tall as well as\n        topiaried to suit your aesthetic whim. Just pot up in light, well-drained soil, keep in a\n        cool, dry, brightly lit spot indoors in winter, and move outdoors to a partially shaded\n        locale in summer. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e441",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Culinarily, what could be more entrancing than to harvest bay leaves off your very own\n        tree (n.b.: leaves don’t develop their full gusto until several weeks after picking and\n        drying), tie them up with some fresh thyme and parsley, and add them to your favorite recipe\n        in the flavorful guise of a classic bouquet garni. As Julia Child so aptly and frequently\n        put it, “Bon appétit!” ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f47009f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch08.vue
// module id = 87
// module chunks = 0